<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.search.provinceId"
              filterable
              clearable
              placeholder="请选择省区"
              style="width:100%"
            >
              <el-option
                v-for="item in provinceOptions"
                :key="item.data"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-col>
          <el-col style="width:60px;padding-left:10px;">
            <el-button
              type="primary"
              @click="searchData()"
            >
              搜索
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @dblclick="viewFun(arguments)"
        @view="viewFun(arguments)"
        @export="batchExport(masterList)"
      />
    </div>
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 定义表头颜色，高度，搜索，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 数据请求
import { loadAreaDataApi } from '@/api/area'
import { loadStoreInfoCollectPlanListDataByStatisticsApi, loadStoreInfoCollectPlanExportDataByStatisticsApi } from '@/api/storeInfoCollectPlan'
export default {
  name: 'StoreInfoCollectPlanStatistics',
  components: {
    CustomTable,
    TableOperation
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'store_info_collect_plan_statistics_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['store_info_collect_plan_statistics_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: 'db.plan_collect_date', // 排序字段
            order: 'desc' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            provinceId: ''
          }
        }
      },
      id: null, // 选中的单据ID
      eventType: '',
      dialogAddEditTitle: '',
      dialogAddEditVisible: false,
      provinceOptions: []
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'provinceName', label: '省区', filterColumn: 'db.province_name', width: 120 },
      { prop: 'cityName', label: '城市', filterColumn: 'db.city_name', width: 120 },
      { prop: 'collectUserName', label: '采集人', filterColumn: 'db.collect_user_name', width: 120 },
      { prop: 'planCollectDateStr', label: '采集日期', filterColumn: 'date_format(db.plan_collect_date,\'%Y-%m-%d\')', width: 120 },
      { prop: 'planCollectAmount1', label: '动销监测计划采集数量', filterColumn: '(ifnull(db1.amount,0)+ifnull(db2.amount,0))' },
      { prop: 'notCollectedAmount1', label: '动销监测未采集数量', filterColumn: 'ifnull(db1.amount,0)' },
      { prop: 'collectedAmount1', label: '动销监测已采集数量', filterColumn: 'ifnull(db2.amount,0)' },
      { prop: 'planCollectAmount2', label: '零售监测计划采集数量', filterColumn: '(ifnull(db3.amount,0)+ifnull(db4.amount,0))' },
      { prop: 'notCollectedAmount2', label: '零售监测未采集数量', filterColumn: 'ifnull(db3.amount,0)' },
      { prop: 'collectedAmount2', label: '零售监测已采集数量', filterColumn: 'ifnull(db4.amount,0)' }
    ]
    // 默认主列表Table列
    this.initProvinceSelectData()
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    searchData () {
      // 重置右键筛选条件
      this.masterList.tableQuery.page = 1
      this.masterList.tableQuery.contextmenuWrap = []
      this.loadTableData()
    },
    // 请求数据
    requestData () {
      this.masterList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.masterList.tableQuery) }
      loadStoreInfoCollectPlanListDataByStatisticsApi(pageCondition).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },
    // 初始省区下拉数据
    initProvinceSelectData () {
      loadAreaDataApi({ parentId: 1, isUserArea: 1 }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.provinceOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 查看
    viewFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      // this.dialogAddEditVisible = !this.dialogAddEditVisible
    },
    // 导出数据API
    ExportByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportObj) }
      loadStoreInfoCollectPlanExportDataByStatisticsApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
